import React from "react";
import { CheckboxTick } from "../../../../public/IconComponents/CheckboxTick";

import { LABEL, CHECK_BOX_INPUT } from "./constants";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const Checkbox = ({
    errors,
    label,
    type = "checkbox",
    field,
    register = () => { return {} },
    locale,
    className,
    checkboxClass
}) => {
    return (
        <div>
            <div className={"flex flex-col mx-auto"}>
                <div className={`flex flex-row items-justify ${className}`}>
                    <input
                        type={type}
                        className={" peer opacity-0 absolute h-6 w-6"}
                        {...register(field)}
                    />
                    <div
                        className={
                            `border peer-checked:bg-Pink_Rose rounded border-New_Primary_Default peer-checked:border-Pink_Rose w-6 h-6 flex flex-shrink-0 justify-center items-center focus-within:border-Pink_Rose ${checkboxClass}`}
                    >
                        <CheckboxTick />
                    </div>
                    {typeof label === "function" ? (
                        label(LABEL(locale))
                    ) : (
                        <p className={LABEL(locale)}>{label}</p>
                    )}
                </div>
                <div>
                    <ErrorTextWithIcon text={errors?.[field]?.message} />
                </div>
            </div>
        </div>
    );
};

export default Checkbox;
